import { data } from '../../svg/Calculator/data';
import { makeIcon } from '../makeIcon';

export const Calculator = makeIcon(data, 'calculator', 'Calculator');

export default Calculator;
